import { render, staticRenderFns } from "./BulmaRadio.vue?vue&type=template&id=3ee4f722"
import script from "./BulmaRadio.vue?vue&type=script&lang=js"
export * from "./BulmaRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports